module.exports = __webpack_public_path__ + "img/main_architecture_image02.bae927f9.jpg";